class CollapsibleComponent extends HTMLElement {
  constructor() {
    super();
    this.links = Array.from(this.querySelectorAll(".collapsible__navigation span"));
    this.sectionTitles = Array.from(this.querySelectorAll('[data-title]'));
    this.details = this.querySelectorAll('.collapsible__details');
    this.summaries = this.querySelectorAll(".collapsible__summary");

    this.init();
  }

  init() {
    gsap.registerPlugin(ScrollTrigger);

    this.sectionTitles.forEach(title => {
      const activeLink = this.links.find(link => link.dataset.section === title.id);
      const tl = gsap.timeline({
        scrollTrigger: {
          scrub: 1,
          trigger: title,
          start: "top 5%",
          end: "bottom 5%",
          toggleActions: "none none none none",
          toggleClass: { targets: `.collapsible__link[data-section="${title.dataset.title}"]`, className: "collapsible__link__active" },
          onLeave: () => {
            const activeLink = this.links.find(link => link.getAttribute('data-section') === title.dataset.title);
            if (activeLink) {
              activeLink.classList.remove("collapsible__link__active");
            }
          }
        },
      });
    });

    this.links.forEach(link => {
      link.addEventListener('click', this.scrollToSection.bind(this));
    });

    this.summaries.forEach(summary => {
      summary.addEventListener('click', this.toggleContent.bind(this));
    });
  }

  toggleContent(event) {
    event.preventDefault();
    const parentElement = event.currentTarget.closest('.collapsible__details');
    const content = event.currentTarget.nextElementSibling;
    parentElement.classList.toggle('active--detail');
    content.offsetHeight == 0 ? this.expandMenu(content) : this.closeMenu(content);    
  }

  expandMenu(target) {
  gsap
    .timeline()
    .to(target, {
      duration: 1,
      height: "auto",
      ease: "power4.out"
    })
}

closeMenu(target) {
  gsap
    .timeline()
    .to(target, {
      duration: 1,
      ease: "power4.out",
      height: 0
    })
}

  scrollToSection(event) {
    event.preventDefault();
    const targetId = event.currentTarget.dataset.section;
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const offset = 100;
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
}

customElements.define('collapsible-component', CollapsibleComponent);
